<template>
    <div class="wrapper-content w-100">
        <h1 v-if="isOnEditMode">Edición {{form.title}}</h1>
        <h1 v-if="!isOnEditMode">Nuevo {{form.title}}</h1>
        <LmForm ref="lmFormRef">
          <h4>Slider</h4>
           <div class="row">
            <LmTextInput
                class="col-12"
                v-model="form.titulo"
                label="Título"
                :v="$v.form.titulo"
                />
          </div>
          <b-form-checkbox class="" v-model="form.default_slider" size="md" name="check-button" >
            Default
          </b-form-checkbox>
          <hr>
        <h4>Imágenes</h4>
        <b-modal
      id="modal-prevent-closing"
      ref="modal"
      :title="isEditImage === true ? 'Editar imagen' : 'Agregar imagen'"
      :ok-title="$t('Agregar')"
      @ok="isEditImage === true ? editModal() : agregarModal()"
      :ok-disabled="form.default_slider ? validationModalDefault() : validationModal()"
      size="xl"
      centered
      scrollable
      no-enforce-focus
    >
        <div>
          <div>
          <LmTextInput
                v-model="name_image"
                label="Nombre"
                />
          <div class="row" v-if="form.default_slider === false">
                     <LmDateTime
            ref="LmDateTimeVigenciaInicio"
            class="col-6"
            v-model="fecha_inicio"
            :config="lmDateTimeConfig"
            label="Fecha inicio de vigencia."
            id="selectDateInicio"
            :layout="['form-group']"
          />

          <LmDateTime
            ref="LmDateTimeVigenciaFin"
            class="col-6"
            v-model="fecha_fin"
            :config="lmDateTimeConfig"
            label="Fecha fin de vigencia."
            id="selectDateFin"
            :layout="['form-group']"
          />
          </div>
          <hr>
          <LmImagenPages v-model="optionsDesktop" v-show="optionsDesktop.image" @fileRemoved="whatComponentOptionsIsIt('optionsDesktop', 'imagen_desktop', 'lmUploadFilesDesktop'); fileRemoved();" class="my-2 mb-4" />
          <LmUploadFiles
              label="Imagen desktop"
              ref="lmUploadFilesDesktop"
              class="mb-3"
              :dropzoneOptions="dropzoneOptions"
              dictDefaultMessage='Arrastre la imagen acá para subirla'
              @vdropzone-removed-file="fileRemoved"
              @vdropzone-success="fileCreated"
              @vdropzone-file-added="whatComponentOptionsIsIt('optionsDesktop', 'imagen_desktop', 'lmUploadFilesDesktop')"
              v-show="!optionsDesktop.image"
          />

          <LmImagenPages v-model="optionsMobile" v-show="optionsMobile.image" @fileRemoved="whatComponentOptionsIsIt('optionsMobile', 'imagen_mobile', 'lmUploadFilesMobile'); fileRemoved();" class="my-2 mb-4" />
          <LmUploadFiles
              label="Imagen mobile"
              ref="lmUploadFilesMobile"
              class="mb-3"
              :dropzoneOptions="dropzoneOptions"
              dictDefaultMessage='Arrastre la imagen acá para subirla'
              @vdropzone-removed-file="fileRemoved"
              @vdropzone-success="fileCreated"
              @vdropzone-file-added="whatComponentOptionsIsIt('optionsMobile', 'imagen_mobile', 'lmUploadFilesMobile')"
              v-show="!optionsMobile.image"
          />
          <LmSelect
        v-model="form.tipo_enlace"
        :options="tipoEnlaceDestinoOptions"
        label="Tipo de enlace de destino"
        @input="cleanAllValuesFromSelect"
        />

        <template v-if="form.tipo_enlace === 'marca'">
          <LmSuperPowerSelectV2
            label="Marcas"
            v-model="marcaSelected"
            urlPathFromGetOptions="marcas/todos/"
          />
        </template>

        <template v-if="form.tipo_enlace === 'landing'">
          <LmSuperPowerSelectV2
            label="Landings"
            v-model="landingSelected"
            urlPathFromGetOptions="landings/todosweb/"
          />
        </template>

        <div v-if="form.tipo_enlace === 'resultado-busqueda'">
          <LmTextInput
                ref="urlBusqueda"
                v-model="url_busqueda"
                label="URL resultado de búsqueda"
                />
        </div>

        <template v-if="form.tipo_enlace === 'filtro'">
          <LmSuperPowerSelectV2
            label="Filtros"
            v-model="filtroSelected"
            urlPathFromGetOptions="filtros/todos/"
          />
        </template>

        <div class="text-danger pt-1 mb-n1" v-if="errorImages">Debe cargar todos los campos en imágenes.</div>

        </div>
        </div>
         </b-modal>

        <div>
                  <draggable tag="ul" :list="form.imagenes" class="list-group w-100 mb-2" handle=".handle" v-bind="dragOptions"
                      @start="disambleBtnAgregarSecciones = true"
                      :key="'dragable'+key"
                      >
                    <transition-group type="transition" :name="'flip-list'">
                      <ul v-for="(item, index) in form.imagenes" :key="index">
                        <li v-bind="dragOptions" class="my-2 my-3 w-50">
                          <div class=" pr-3 float-left">
                            <font-awesome-icon class="handle" size="lg" icon="bars" />
                          </div>
                          {{ item.name }}
                          <div class=" pr-3 float-right" @click.prevent="deleteImagen(index)">
                            <font-awesome-icon class="trash" size="lg" icon="trash" />
                          </div>
                          <div class="pr-3 float-right"
                          @click.prevent="clickEdit(item, index)"
                          v-b-modal.modal-prevent-closing
                          >
                            <font-awesome-icon class="edit" size="lg" icon="edit" />
                          </div>
                        </li>
                      </ul>
                    </transition-group>
                  </draggable>

                  <LmButton
        id="btn-agregarImagen"
        type="button"
        buttonClass="btn-primary mb-1"
        :isProcessing="formIsProcessing"
        :value="$t('Agregar imagen')"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="agregarImagen"
        v-b-modal.modal-prevent-closing
        />
      <div v-if="form.imagenes.length > 0">
        <h4>Preview</h4>

                  <b-tabs content-class="mt-3" lazy>
          <b-tab title="Desktop">
            <b-carousel
                      id="carousel-1"
                      :interval="4000"
                      controls
                      indicators
                      background="#ababab"
                      img-width="1024"
                      img-height="480"
                      style="text-shadow: 1px 1px 2px #333;"
                    >
                        <!-- Text slides with image -->
                        <div v-for="(item, index) in form.imagenes" :key="`${item.fecha_inicio}-${item.fecha_fin}-${index}`">
                          <b-carousel-slide
                            :img-src="baseUrl + item.imagen_desktop"
                            v-if="isVigente(item.fecha_inicio, item.fecha_fin)"
                          ></b-carousel-slide>
                        </div>
            </b-carousel>
          </b-tab>
          <b-tab title="Mobile">
            <div class="w-50 m-auto">
            <b-carousel
                      id="carousel-2"
                      :interval="4000"
                      controls
                      indicators
                      background="#ababab"
                      img-width="1024"
                      img-height="480"
                      style="text-shadow: 1px 1px 2px #333;"
                    >
                    <div v-for="(item, index) in form.imagenes" :key="`${item.fecha_inicio}-${item.fecha_fin}-${index}`">
                        <b-carousel-slide
                          :img-src="baseUrl + item.imagen_mobile"
                          v-if="isVigente(item.fecha_inicio, item.fecha_fin)"
                        ></b-carousel-slide>
                      </div>
                      </b-carousel>
                      </div>
          </b-tab>
        </b-tabs>
        </div>
        </div>
        <hr>

      <div class="mt-4">
        <LmButton
        id="btn-cancel"
        type="button"
        buttonClass="btn-secondary"
        :isProcessing="formIsProcessing"
        :value="$t('Cancel')"
        @click.native="cancelBtn"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        />
        <LmButton
              id="btn-guardar"
              type="submit"
              buttonClass="btn-success"
              :isProcessing="formIsProcessing"
              :value="$t('Save')"
              lmButtonRootWrapperClass="d-inline-block mr-1"
              lmButtonWrapperClass="col"
              @click.native="submit('guardar')"
          />
        <LmButton
            id="btn-guardarysalir"
            type="submit"
            buttonClass="btn-primary"
            :isProcessing="formIsProcessing"
            :value="$t('Guardar y salir')"
            lmButtonRootWrapperClass="d-inline-block mr-1"
            lmButtonWrapperClass="col"
            @click.native="submit('guardarSalir')"
        />
      </div>
    </LmForm>
    </div>
</template>

<script>
import store from '@/store'
import axios from 'axios'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'

import LmForm from '@/components/form/LmForm.vue'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmUploadFiles from '@/components/LmUploadFiles'
import LmImagenPages from '@/views/365/pages/elements/LmImagenPages'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2.vue'
import LmSelect from '@/components/form/elements/LmSelect.vue'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmButton from '@/components/form/elements/LmButton'
import draggable from 'vuedraggable'

export default {
  components: {
    LmForm,
    LmTextInput,
    LmUploadFiles,
    LmImagenPages,
    LmSelect,
    LmSuperPowerSelectV2,
    LmDateTime,
    LmButton,
    draggable
  },
  data () {
    return {
      titulo: '',
      marcaSelected: {},
      landingSelected: {},
      filtroSelected: {},
      nameComponentOptions: '',
      nameFormImage: '',
      refComponent: '',
      initialForm: {},
      formIsProcessing: false,
      errorImages: false,
      toggleContentImages: false,
      isEditImage: false,
      indexImageClick: null,
      key: 0,
      name_image: '',
      url_busqueda: '',
      fecha_inicio: '',
      fecha_fin: '',
      files: [],
      baseUrl: process.env.VUE_APP_API_URL_STATIC_ASSETS,
      tipoEnlaceDestinoOptions: {
        content: [
          { value: 'marca', text: 'Marca' },
          { value: 'landing', text: 'Landing' },
          { value: 'resultado-busqueda', text: 'Resultado de búsqueda' },
          { value: 'filtro', text: 'Filtro' }
        ]
      },
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}documentos/nuevo/`,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null,
          Authorization: `Bearer ${store.state.session.accessToken}`
        },
        withCredentials: true,
        thumbnailWidth: 150,
        maxFiles: 1,
        addRemoveLinks: true,
        acceptedFiles: 'image/*'
      },
      optionsDesktop: {
        type: Object,
        idRandom: '',
        id: '',
        title: '',
        image: '',
        imageOriginalName: '',
        imageSize: '',
        default: () => ({
          disabledOption: 'Seleccione una acción',
          content: []
        })
      },
      optionsMobile: {
        type: Object,
        idRandom: '',
        id: '',
        title: '',
        image: '',
        imageOriginalName: '',
        imageSize: '',
        default: () => ({
          disabledOption: 'Seleccione una acción',
          content: []
        })
      },
      lmDateTimeConfig: {
        dateFormat: 'Y-m-d H:i',
        allowInput: true,
        enableTime: true,
        minDate: 0
      },
      form: {
        imagenes: [],
        name_image: '',
        titulo: '',
        imagen_desktop: '',
        imagen_mobile: '',
        tipo_enlace: '',
        url_busqueda: '',
        default_slider: false,
        fecha_inicio: '',
        fecha_fin: ''
      }
    }
  },
  computed: {
    dragOptions () {
      return {
        animation: 200,
        group: 'transition',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
    nameState () {
      return this.name_image.length > 2
    }
  },
  methods: {
    validationModalDefault () {
      let result = null
      if (
        (this.optionsDesktop.image === '' || this.optionsMobile.image === '' || this.name_image === '' || this.form.tipo_enlace === '') ||
        (!this.marcaSelected?.id && !this.landingSelected?.id && !this.filtroSelected?.id && this.url_busqueda.length === 0)) {
        result = true
      } else {
        result = false
      }
      return result
    },
    validationModal () {
      let result = null
      if (
        (this.optionsDesktop.image === '' || this.optionsMobile.image === '' || this.name_image === '' || this.form.tipo_enlace === '' || (this.fecha_inicio === undefined || this.fecha_inicio === '') || (this.fecha_fin === undefined || this.fecha_fin === '')) ||
        (!this.marcaSelected?.id && !this.landingSelected?.id && !this.filtroSelected?.id && this.url_busqueda.length === 0)) {
        result = true
      } else {
        result = false
      }
      return result
    },
    isVigente (fechaInicio, fechaFin) {
      let result = null
      if (this.form.default_slider) {
        result = true
      } else {
        result = moment().isBetween(fechaInicio, fechaFin)
      }
      return result
    },
    clickEdit (item, index) {
      this.toggleContentImages = true
      console.log(item)
      console.log(index)
      this.name_image = item.name
      this.optionsDesktop.image = item.imagen_desktop
      this.optionsMobile.image = item.imagen_mobile
      this.form.tipo_enlace = item.tipo_enlace
      this.url_busqueda = item.url_busqueda
      this.marcaSelected.id = item.id_marca
      this.landingSelected = item.id_landing
      this.filtroSelected = item.id_filtro
      this.fecha_inicio = item.fecha_inicio
      this.fecha_fin = item.fecha_fin
      this.isEditImage = true
      this.indexImageClick = index
    },
    deleteImagen (index) {
      this.form.imagenes.splice(index, 1)
    },
    agregarImagen () {
      this.isEditImage = false
      this.resetModal()
    },
    editModal () {
      this.form.imagenes[this.indexImageClick] = {
        name: this.name_image,
        imagen_desktop: this.optionsDesktop.image,
        imagen_mobile: this.optionsMobile.image,
        tipo_enlace: this.form.tipo_enlace,
        url_busqueda: this.url_busqueda,
        id_marca: this.marcaSelected.id,
        id_landing: this.landingSelected,
        id_filtro: this.filtroSelected,
        fecha_inicio: this.fecha_inicio,
        fecha_fin: this.fecha_fin
      }
      this.key++
    },
    agregarModal () {
      if (this.optionsDesktop.image && this.optionsMobile.image && this.name_image) {
        this.form.imagenes.push(
          {
            name: this.name_image,
            imagen_desktop: this.optionsDesktop.image,
            imagen_mobile: this.optionsMobile.image,
            tipo_enlace: this.form.tipo_enlace,
            url_busqueda: this.url_busqueda,
            id_marca: this.marcaSelected.id,
            id_landing: this.landingSelected,
            id_filtro: this.filtroSelected,
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin
          }
        )
        this.errorImages = false
        this.resetModal()
      } else {
        this.errorImages = true
      }
    },
    resetModal () {
      this.name_image = ''
      this.form.imagen_name = ''
      this.form.imagen_desktop = ''
      this.form.imagen_mobile = ''
      this.optionsDesktop.image = ''
      this.optionsMobile.image = ''
      this.url_busqueda = ''
      this.marcaSelected = {}
      this.landingSelected = {}
      this.filtroSelected = {}
      this.form.tipo_enlace = ''
      this.fecha_inicio = ''
      this.fecha_fin = ''
      // this.$refs.lmUploadFilesDesktop.lmRemoveAllFiles()
      // this.$refs.lmUploadFilesMobile.lmRemoveAllFiles()
    },
    async submit (guardarType) {
      try {
        await this.$refs.lmFormRef.validationForm(this.$v)
        this.formIsProcessing = true
        // const fileLoaded = this.files.length ? this.files[0].path : ''
        const dataToSendToTheServer = {
          titulo: this.form.titulo,
          imagenes: this.form.imagenes,
          default_slider: this.form.default_slider,
          id: this.$route.params.id
        }

        let apiUrl = this.isOnEditMode ? `${process.env.VUE_APP_API_URL}sliders/edit-sliders/` : `${process.env.VUE_APP_API_URL}sliders/new/`
        await axios.post(
          apiUrl,
          dataToSendToTheServer,
          {
            headers: {
              Authorization: `Bearer ${store.state.session.accessToken}`
            }
          }
        )

        if (guardarType === 'guardarSalir') {
          this.$router.push('/sliders/listado')
        } else {
          this.makeToast('guardar')
          if (!this.isOnEditMode) {
            this.$nextTick(function () {
              this.form.titulo = ''
              this.form.imagenes = ''
              this.optionsDesktop.image = ''
              this.optionsMobile.image = ''
              this.form.tipo_enlace = ''
              this.url_busqueda = ''
              this.marcaSelected = {}
              this.landingSelected = {}
              this.filtroSelected = {}
              this.form.default_slider = false
              if (this.form.default_slider) {
                this.$refs.LmDateTimeVigenciaInicio.clear()
                this.$refs.LmDateTimeVigenciaFin.clear()
              }
              this.$refs.lmUploadFilesDesktop.lmRemoveAllFiles()
              this.$refs.lmUploadFilesMobile.lmRemoveAllFiles()
              this.$v.$reset()
            })
          }
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.formIsProcessing = false
      }
    },
    cancelBtn () {
      this.$router.push('/sliders/listado')
    },
    async setForm () {
      if (this.isOnEditMode) {
        await this.$refs.lmFormRef.activeEditMode({
          path: 'sliders/read-sliders',
          id: this.$route.params.id,
          paramsMode: true
        })
          .catch(error => {
            console.log(error)
            this.$router.replace({ name: '404' })
          })
      } else {
        this.form = JSON.parse(this.initialForm)
        this.$refs.lmFormRef.showLoading()
        // this.$refs.lmUploadFilesDesktop.lmRemoveAllFiles()
        this.form.imagen_desktop = ''
        this.optionsDesktop.image = ''
        // imagen mobile
        // this.$refs.lmUploadFilesMobile.lmRemoveAllFiles()
        this.form.imagen_mobile = ''
        this.optionsMobile.image = ''
        setTimeout(() => {
          this.$v.$reset()
          this.$refs.lmFormRef.hideLoading()
        }, 200)
      }
    },
    makeToast (variant = null) {
      if (variant === 'guardar') {
        this.$bvToast.toast('El contenido se guardó exitosamente.', {
          title: `Mensaje`,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-bottom-center'
        })
      }
    },
    whatComponentOptionsIsIt (nameComponentOptions, nameFormImage, refComponent) {
      this.nameComponentOptions = nameComponentOptions
      this.nameFormImage = nameFormImage
      this.refComponent = refComponent
    },
    fileCreated (file, response) {
      let options = this.nameComponentOptions
      let nameFormImage = this.nameFormImage
      // let refComponent = this.refComponent
      if (response) {
        setTimeout(() => {
          this[options].idRandom = Math.random()
        }, 1000
        )
        // this.form.title = response.path
        this[options].image = response.path
        this[options].tag = response.tag
        this[options].imageSize = this.bytesToSize(response.size)
        this.form[nameFormImage] = response.path
        this.files.push(response)
      }
      // this.$refs[refComponent].disable()
    },
    fileRemoved (file, error, xhr) {
      let options = this.nameComponentOptions
      let nameFormImage = this.nameFormImage
      let refComponent = this.refComponent

      this.form[nameFormImage] = ''
      this[options].image = ''
      this.files = []
      if (file) {
        this.files = this.files.filter(f => f.originalname !== file.name)
      }
      this.$refs[refComponent].lmRemoveAllFiles()
      this.$refs[refComponent].enable()
    },
    bytesToSize (bytes) {
      const sizes = ['bytes', 'kb', 'mb', 'gb', 'tb']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(Math.abs(bytes)) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
    },
    cleanAllValuesFromSelect () {
      this.url_busqueda = ''
      this.marcaSelected = {}
      this.landingSelected = {}
      this.filtroSelected = {}
    }
  },
  validations: {
    form: {
      titulo: {
        required
      },
      imagenes: {
        required
      }
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isOnEditMode () {
      this.setForm()
    }
  },
  created () {
    this.initialForm = JSON.stringify(this.form)
  },
  mounted () {
    this.setForm()
  }
}
</script>

<style scoped>
.trash{
  cursor: pointer;
}
</style>
